module.exports = __webpack_public_path__ + "static/media/SofiaProMediumItalic.7517a7e3.otf";